
import Header from '../components/Header'
import Breadcrumb from "../components/Breadcrumb";
import Footer from '../components/Footer';
const AboutUs = () => {
    return(
        <>
            <Header/>
            <Breadcrumb pageTitle="Clubs and Association" mid="Student Corner" breadcrumbName="Clubs and Association" />
            <div className="inner-page">
                    <div className='container'>
                        <div className='row'>
                            
                             
                            <div className='col-lg-12 col-md-12 animateMe'  data-animation="fadeInRight">
                                <p>There are various clubs and associations active to insight a special love for different subjects. There are various programmes and activities held throughout the academic year. Student's active participation under the guidance of the teachers helps to develop the personalities of the children, in all dimensions.</p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
        </>
    )
}
export default AboutUs